import React from 'react';

/**
 * Small uppercase, letter-spaced section label — the brand's core structural
 * device. Optional small Lucide icon sits to the left and inherits the label
 * colour (stroke=currentColor). Icons are used ONLY here, next to section
 * labels — never on individual items, tags, or decoratively.
 *
 * tone: 'light' (navy label on beige) | 'navy' (soft label on navy fill)
 */
const SectionLabel = ({ icon: Icon, children, tone = 'light', className = '' }) => {
  const color = tone === 'navy' ? 'text-[#A6C0DB]' : 'text-navy-600';
  return (
    <div className={`flex items-center gap-2 ${color} ${className}`}>
      {Icon && <Icon size={12} strokeWidth={1.75} className="flex-shrink-0" aria-hidden="true" />}
      <span className="text-xs font-semibold uppercase tracking-label">{children}</span>
    </div>
  );
};

export default SectionLabel;
